import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dbf3681a&lang=html&"
import script from "./home.js?vue&type=script&lang=js&"
export * from "./home.js?vue&type=script&lang=js&"
import style0 from "./home.styl?vue&type=style&index=0&lang=stylus&"
import style1 from "./resetVant.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports